<template>
    <div class="b_pagination">
        <div class="pagination text_center">
            <ul class="pagination_list">
                <li>
                    <a
                        class="pag_prev"
                        :class="{ disabled: isPreviousButtonDisabled }"
                        @click="previousPage"
                    />
                </li>

                <li
                    v-for="paginationTrigger in paginationTriggers"
                    :key="paginationTrigger"
                    :class="{
                        active: paginationTrigger === currentPage
                    }"
                    @load-page="onLoadPage"
                >
                    <a @click="onLoadPage(paginationTrigger)">
                        {{ paginationTrigger }}
                    </a>
                </li>

                <li>
                    <a
                        class="pag_next"
                        :class="{ disabled: isNextButtonDisabled }"
                        @click="nextPage"
                    />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentPage: {
            type: Number,
            required: true
        },

        pageCount: {
            type: Number,
            required: true
        },

        visiblePagesCount: {
            type: Number,
            default: 5
        },

        isMobile: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        isPreviousButtonDisabled() {
            return this.currentPage === 1;
        },

        isNextButtonDisabled() {
            return this.currentPage === this.pageCount;
        },

        paginationTriggers() {
            if (this.isMobile) {
                return [];
            }

            const currentPage = this.currentPage;
            const pageCount = this.pageCount;
            const visiblePagesCount =
                this.pageCount >= this.visiblePagesCount
                    ? this.visiblePagesCount
                    : this.pageCount;
            const visiblePagesThreshold = Math.ceil(
                (visiblePagesCount - 1) / 2
            );

            if (visiblePagesCount <= 0) {
                return [];
            }

            if (visiblePagesCount === 1) {
                return [1];
            }

            const paginationTriggersArray = Array(visiblePagesCount - 1).fill(
                0
            );

            if (currentPage <= visiblePagesThreshold + 1) {
                paginationTriggersArray[0] = 1;

                return this.calculatePaginationTriggers({
                    array: paginationTriggersArray,
                    mapOperation: value => paginationTriggersArray[0] + value,
                    callback: result => result.push(pageCount)
                });
            }

            if (currentPage >= pageCount - visiblePagesThreshold + 1) {
                return this.calculatePaginationTriggers({
                    array: paginationTriggersArray,
                    mapOperation: value => pageCount - value,
                    callback: result => result.reverse().unshift(1)
                });
            }

            paginationTriggersArray[0] =
                currentPage - visiblePagesThreshold + 1;

            return this.calculatePaginationTriggers({
                array: paginationTriggersArray,
                mapOperation: value => paginationTriggersArray[0] + value,
                callback: result => {
                    result.unshift(1);
                    result[result.length - 1] = pageCount;
                }
            });
        }
    },

    methods: {
        nextPage() {
            this.$emit('next-page');
        },

        previousPage() {
            this.$emit('previous-page');
        },

        onLoadPage(value) {
            this.$emit('load-page', value);
        },

        calculatePaginationTriggers({ array, mapOperation, callback = null }) {
            const result = array.map((triggers, index) => mapOperation(index));

            if (callback) {
                callback(result);
            }

            return result;
        }
    }
};
</script>
